RivalIQ.apps.Insights.module('curations', function (curations, App, Backbone, Marionette, $, _) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;
    const widgetTypes = RivalIQ.enums.widgetTypes;

    const widgets = [
        {
            instanceId: 'paid-reach-notification',
            widgetId: RivalIQ.enums.widgetTypes.PAID_REACH_NOTIFICATION,
            supportedExportFormats: [],
            region: 'top'
        },
        {
            instanceId: 'additional-auth-facebook',
            widgetId: RivalIQ.enums.widgetTypes.ADDITIONAL_AUTHORIZATION,
            region: 'top',
            supportedExportFormats: [],
            props: {
                source: RivalIQ.enums.sources.FACEBOOK_INSIGHTS
            }
        },
        {
            instanceId: 'fb-ads-token-request',
            widgetId: RivalIQ.enums.widgetTypes.FB_ADS_TOKEN_REQUEST,
            region: 'top',
            supportedExportFormats: [],
            props: {
                source: RivalIQ.enums.sources.FACEBOOK_INSIGHTS
            }
        },
        {
            instanceId: 'insights-post-details',
            widgetId: widgetTypes.FB_INSIGHTS_POST_DETAILS,
            region: 'top'
        },
        {
            instanceId: 'insights-post-at-a-glance',
            widgetId: widgetTypes.FB_INSIGHTS_POST_AT_A_GLANCE,
            region: 'top'
        },
        {
            instanceId: 'insights-post-reach',
            widgetId: widgetTypes.FB_INISGHTS_POST_REACH_AND_IMPRESSIONS,
            region: 'top'
        },
        {
            instanceId: 'insights-post-engagement-summary',
            widgetId: widgetTypes.FB_INSIGHTS_POST_ENGAGEMENT_SUMMARY,
            region: 'top'
        },
        {
            instanceId: 'insights-post-social-engagement',
            widgetId: widgetTypes.FB_INSIGHTS_POST_SOCIAL_ENGAGEMENT,
            region: 'top'
        },
        {
            instanceId: 'insights-post-social-engagement-breakdown',
            widgetId: widgetTypes.FB_INSIGHTS_POST_SOCIAL_ENGAGEMENT_BREAKDOWN,
            region: 'top'
        },
        {
            instanceId: 'insights-post-reactions-breakdown',
            widgetId: widgetTypes.FB_INSIGHTS_POST_REACTIONS,
            region: 'top'
        },
        {
            instanceId: 'insights-post-video-details',
            widgetId: widgetTypes.FB_INSIGHTS_POST_VIDEO_DETAILS,
            region: 'top'
        },
        {
            instanceId: 'insights-post-insights-consumption',
            widgetId: widgetTypes.FB_INSIGHTS_POST_INSIGHTS_CONSUMPTION,
            region: 'left'
        },
        {
            instanceId: 'insights-post-ads-consumption',
            widgetId: widgetTypes.FB_INSIGHTS_POST_ADS_CONSUMPTION,
            region: 'right'
        }
    ];

    const config = [
        {
            name: 'top',
            sizes: {
                md: 12
            },
            page: 0
        },
        [
            {
                name: 'left',
                sizes: {
                    sm: 12,
                    md: 6
                },
                page: 0
            },
            {
                name: 'right',
                sizes: {
                    sm: 12,
                    md: 6
                },
                page: 0
            }
        ]
    ];

    const channelWall = Dashboard.curations.filters.ChannelFilterFactory({
        template: '#widgetFacebookInsightsAuthTemplate',
        upsellTemplate: '#widgetFacebookInsightsUpsellTemplate',
        channel: RivalIQ.enums.sources.FACEBOOK_INSIGHTS
    });

    const FacebookInsightsPostDetailsLayout = Dashboard.views.CurationLayout.extend({
        config: config,

        showLeftToolbarActions: function () {
            const me = this;
            me.showBackLink();
        },

        showBackLink: function () {
            const me = this;

            const name = me.dashboardModel.getBackLinkName();
            me.leftActions.show(new RivalIQ.views.Link({
                className: 'btn btn-link',
                linkName: `<span class="fa fa-chevron-left"></span><span>${name}</span>`,
                attributes: function () {
                    return {
                        href: me.dashboardModel.getBackPath()
                    };
                }
            }), {
                preventDestroy: true
            });

        }
    });

    const FacebookInsightsPostDetailsExportLayout = Dashboard.views.ExportWidgets.extend({
        childView: Dashboard.views.ExportLayout.extend({
            config: config
        })
    });

    const page = RivalIQ.configuration.menus.getConfiguration().FACEBOOK_INSIGHTS;

    curations.FacebookInsightsPostDetailsCuration = Dashboard.models.Curation.extend({
        beforeFilters: [
            curations.filters.fbPresenceLoader,
            channelWall,
            curations.filters.noFacebookInsightsPresences,
            curations.filters.checkAccountAccess(RivalIQ.enums.sources.FACEBOOK_INSIGHTS),
            curations.filters.insightsLoading(RivalIQ.enums.sources.FACEBOOK_INSIGHTS, '/insights/facebook'),
            curations.filters.loadInsightsPostCurationProperties
        ],

        widgetsView: FacebookInsightsPostDetailsLayout,
        exportWidgetsView: FacebookInsightsPostDetailsExportLayout,

        getBackLinkName: function () {
            const me = this;

            if (me.getProp('from') === 'posts') {
                return RivalIQ.strings.facebook_insights_post_detail_back_link;
            }

            return Dashboard.models.Curation.prototype.getBackLinkName.apply(me, arguments);
        },

        getBackPath: function (widgetProps) {
            const me = this;

            const backPathProps = {
                companyId: me.getProp('companyId'),
                instanceId: me.getProp('from')
            };

            const fromProps = me.getProp('fromProps');

            const fromCuration = me.getProp('fromCuration') || RivalIQ.enums.curation.FACEBOOK_INSIGHTS;

            return me.router.resolveCurationRoute(fromCuration, _.extend(backPathProps, fromProps, widgetProps));
        },

        getFilename: function () {
            const me = this;

            return RivalIQ.export.filename.base({
                title: _.result(me, 'title'),
                landscapeName: RivalIQ.state.view.get('landscapeName'),
                companyId: me.getProp('companyId')
            });
        },

        page: page,
        title: page.name,
        exportTitle: 'Facebook Insights Post Details',

        buildConfiguration: function () {
            return new RivalIQ.apps.Dashboard.models.Configuration({
                definitions: widgets
            });
        },

        getBasePath: function (props) {
            const me = this;
            const defaults = {
                companyId: me.getProp('companyId'),
                postId: me.getProp('postId')
            };
            return me.router.resolveCurationRoute(me.id, _.extend(defaults, props));
        },

        processProps: function (props) {
            return _.defaults({
                channel: RivalIQ.enums.channels.FACEBOOK
            }, props);
        },

        canLoadAds: function () {
            const me = this;

            const boostedPosts = RivalIQ.state.account.channelDisplay(RivalIQ.enums.sourceMask.FACEBOOK_BOOSTED_POST_INSIGHTS);
            return boostedPosts && me.sources[RivalIQ.enums.sources.FACEBOOK_BOOSTED_POST_INSIGHTS].validToken;
        },

        parseParams: function (params) {
            const me = this;
            const parsed = RivalIQ.apps.Dashboard.models.Curation.prototype.parseParams.call(me, params);

            return RivalIQ.utils.queryParams.forceSearchParamsToString(parsed, RivalIQ.enums.searchFieldNames);
        }
    });
});
